import { memo, useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Typography } from 'antd';

import styles from './BidsListButton.module.css';
import BidsList from './BidsList';
import { useSearchParams } from 'react-router-dom';
import { openBidsListParam } from './constants';
import { LinkOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface BidsListButtonProps {
  auctionId: string;
  bidCount: number;
}

function BidsListButton({ auctionId, bidCount }: BidsListButtonProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [showBidsList, setShowBidsList] = useState<boolean>(false);

  useEffect(() => {
    setShowBidsList(searchParams.get(openBidsListParam.key) === openBidsListParam.value);
  }, [searchParams]);

  const closeBidsList = () => {
    if (searchParams.get(openBidsListParam.key)) {
      searchParams.delete(openBidsListParam.key);
      setSearchParams(searchParams, { replace: true });
    }
    setShowBidsList(false);
  };

  return (
    <>
      <Button
        className={`no-padding ${styles.btn}`}
        type="link"
        onClick={() => {
          setShowBidsList(true);
        }}
      >
        {`${bidCount} bid(s)`}
      </Button>
      <Modal
        title={
          <Row gutter={4} align="middle">
            <Col>입찰 내역</Col>
            <Col>
              <Text
                copyable={{
                  text: `${window.location.origin}${window.location.pathname}?${openBidsListParam.key}=${openBidsListParam.value}`,
                  icon: [<LinkOutlined key="copy-icon" />, <LinkOutlined key="copied-icon" />],
                  tooltips: ['Copy Link', 'Copied!'],
                }}
              />
            </Col>
          </Row>
        }
        footer={null}
        wrapClassName={styles.modal}
        centered
        open={showBidsList}
        onCancel={closeBidsList}
      >
        <BidsList auctionId={showBidsList ? auctionId : undefined} bidCount={bidCount} />
      </Modal>
    </>
  );
}

export default memo(BidsListButton);
